// This file is auto-generated by @hey-api/openapi-ts
import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import {
  deleteCommentsByIdUnlikeResponseTransformer,
  deletePostsByIdUnlikeResponseTransformer,
  getClubsByIdFeedResponseTransformer,
  getUsersByIdPostsResponseTransformer,
  getUsersFeedNewsResponseTransformer,
  getUsersFeedPostsResponseTransformer,
  getUsersFeedResponseTransformer,
  postCommentsByIdLikeResponseTransformer,
  postPostsByIdLikeResponseTransformer,
  postPostsResponseTransformer,
} from './transformers.gen';
import type {
  DeleteBonusesByIdData,
  DeleteBonusesByIdErrors,
  DeleteBonusesByIdResponses,
  DeleteCommentsByIdUnlikeData,
  DeleteCommentsByIdUnlikeErrors,
  DeleteCommentsByIdUnlikeResponses,
  DeleteCustomBannersByIdData,
  DeleteCustomBannersByIdErrors,
  DeleteCustomBannersByIdResponses,
  DeleteDrawsByIdData,
  DeleteDrawsByIdErrors,
  DeleteDrawsByIdResponses,
  DeleteEndorsementsByIdData,
  DeleteEndorsementsByIdErrors,
  DeleteEndorsementsByIdResponses,
  DeleteMatchesByIdData,
  DeleteMatchesByIdErrors,
  DeleteMatchesByIdResponses,
  DeleteOffersByIdData,
  DeleteOffersByIdErrors,
  DeleteOffersByIdResponses,
  DeletePositionedBannersByIdData,
  DeletePositionedBannersByIdResponses,
  DeletePostsByIdUnlikeData,
  DeletePostsByIdUnlikeErrors,
  DeletePostsByIdUnlikeResponses,
  DeletePostsByPostIdCommentsByIdData,
  DeletePostsByPostIdCommentsByIdErrors,
  DeletePostsByPostIdCommentsByIdResponses,
  DeletePremiumTokensByIdData,
  DeletePremiumTokensByIdErrors,
  DeletePremiumTokensByIdResponses,
  DeleteSavedCompetitionSearchData,
  DeleteSavedCompetitionSearchErrors,
  DeleteSavedCompetitionSearchResponses,
  DeleteSessionsByIdData,
  DeleteSessionsByIdResponses,
  DeleteUserMatchesByIdData,
  DeleteUserMatchesByIdErrors,
  DeleteUserMatchesByIdResponses,
  GetBonusesData,
  GetBonusesErrors,
  GetBonusesResponses,
  GetCardinalityData,
  GetCardinalityResponses,
  GetClubsByIdData,
  GetClubsByIdErrors,
  GetClubsByIdFeedData,
  GetClubsByIdFeedErrors,
  GetClubsByIdFeedResponses,
  GetClubsByIdResponses,
  GetClubsIdByFitClubIdByFitClubIdData,
  GetClubsIdByFitClubIdByFitClubIdErrors,
  GetClubsIdByFitClubIdByFitClubIdResponses,
  GetCompetitionsByIdData,
  GetCompetitionsByIdErrors,
  GetCompetitionsByIdResponses,
  GetCompetitionsSearchData,
  GetCompetitionsSearchResponses,
  GetCustomBannersAllData,
  GetCustomBannersAllResponses,
  GetCustomBannersByIdData,
  GetCustomBannersByIdErrors,
  GetCustomBannersByIdResponses,
  GetCustomBannersData,
  GetCustomBannersResponses,
  GetDrawsByIdData,
  GetDrawsByIdErrors,
  GetDrawsByIdResponses,
  GetEditProfileProfilesData,
  GetEditProfileProfilesErrors,
  GetEditProfileProfilesResponses,
  GetFakeRouteToTestLoginCheckData,
  GetFakeRouteToTestLoginCheckErrors,
  GetFakeRouteToTestLoginCheckResponses,
  GetFeedNewsData,
  GetFeedNewsResponses,
  GetFitPlayerProfileRequestsData,
  GetFitPlayerProfileRequestsResponses,
  GetFitPlayerProfilesAdvancedSearchFiltersData,
  GetFitPlayerProfilesAdvancedSearchFiltersResponses,
  GetFitPlayerProfilesByIdData,
  GetFitPlayerProfilesByIdEndorsementsData,
  GetFitPlayerProfilesByIdEndorsementsResponses,
  GetFitPlayerProfilesByIdErrors,
  GetFitPlayerProfilesByIdFeedData,
  GetFitPlayerProfilesByIdFeedResponses,
  GetFitPlayerProfilesByIdHarmonizationData,
  GetFitPlayerProfilesByIdHarmonizationErrors,
  GetFitPlayerProfilesByIdHarmonizationResponses,
  GetFitPlayerProfilesByIdRankData,
  GetFitPlayerProfilesByIdRankResponses,
  GetFitPlayerProfilesByIdReducedData,
  GetFitPlayerProfilesByIdReducedResponses,
  GetFitPlayerProfilesByIdResponses,
  GetFitPlayerProfilesByIdSimulatorData,
  GetFitPlayerProfilesByIdSimulatorErrors,
  GetFitPlayerProfilesByIdSimulatorResponses,
  GetFitPlayerProfilesByIdStatsData,
  GetFitPlayerProfilesByIdStatsResponses,
  GetFitPlayerProfilesByIdUserInfoData,
  GetFitPlayerProfilesByIdUserInfoResponses,
  GetFitPlayerProfilesByIdVisitorsData,
  GetFitPlayerProfilesByIdVisitorsResponses,
  GetFitPlayerProfilesByIdVisitsData,
  GetFitPlayerProfilesByIdVisitsResponses,
  GetFitPlayerProfilesByIdWrappedData,
  GetFitPlayerProfilesByIdWrappedResponses,
  GetFitPlayerProfilesCardToIdByCardNumberData,
  GetFitPlayerProfilesCardToIdByCardNumberErrors,
  GetFitPlayerProfilesCardToIdByCardNumberResponses,
  GetFitPlayerProfilesFollowersListByIdData,
  GetFitPlayerProfilesFollowersListByIdResponses,
  GetFitPlayerProfilesMostVisitedData,
  GetFitPlayerProfilesMostVisitedResponses,
  GetFitPlayerProfilesSearchData,
  GetFitPlayerProfilesSearchForMergeByQData,
  GetFitPlayerProfilesSearchForMergeByQResponses,
  GetFitPlayerProfilesSearchForMergeData,
  GetFitPlayerProfilesSearchForMergeResponses,
  GetFitPlayerProfilesSearchResponses,
  GetHomeBackofficeNumbersData,
  GetHomeBackofficeNumbersResponses,
  GetHomeData,
  GetHomeNotificationsData,
  GetHomeNotificationsResponses,
  GetHomeNumbersData,
  GetHomeNumbersResponses,
  GetHomeRateData,
  GetHomeRateResponses,
  GetHomeResponses,
  GetMatchesByIdData,
  GetMatchesByIdErrors,
  GetMatchesByIdResponses,
  GetMatchesData,
  GetMatchesResponses,
  GetMessagesConversationData,
  GetMessagesConversationResponses,
  GetOffersByIdData,
  GetOffersByIdErrors,
  GetOffersByIdResponses,
  GetOffersPrivatesData,
  GetOffersPrivatesErrors,
  GetOffersPrivatesResponses,
  GetOffersShopsData,
  GetOffersShopsResponses,
  GetPositionedBannersByIdByIdData,
  GetPositionedBannersByIdByIdErrors,
  GetPositionedBannersByIdByIdResponses,
  GetPositionedBannersBySlotData,
  GetPositionedBannersBySlotErrors,
  GetPositionedBannersBySlotResponses,
  GetPositionedBannersData,
  GetPositionedBannersResponses,
  GetPremiumTokensByIdData,
  GetPremiumTokensByIdErrors,
  GetPremiumTokensByIdResponses,
  GetPremiumTokensData,
  GetPremiumTokensResponses,
  GetSavedCompetitionSearchData,
  GetSavedCompetitionSearchErrors,
  GetSavedCompetitionSearchResponses,
  GetTournamentsByIdData,
  GetTournamentsByIdErrors,
  GetTournamentsByIdResponses,
  GetUpdateTasksData,
  GetUpdateTasksResponses,
  GetUserMatchesByIdData,
  GetUserMatchesByIdErrors,
  GetUserMatchesByIdResponses,
  GetUserMatchesData,
  GetUserMatchesResponses,
  GetUsersByIdData,
  GetUsersByIdPostsData,
  GetUsersByIdPostsResponses,
  GetUsersByIdPreviewData,
  GetUsersByIdPreviewResponses,
  GetUsersByIdResponses,
  GetUsersByTokenFitPlayerIdData,
  GetUsersByTokenFitPlayerIdResponses,
  GetUsersConfirmAccountByTokenData,
  GetUsersConfirmAccountByTokenResponses,
  GetUsersFacebookInfoByTokenData,
  GetUsersFacebookInfoByTokenResponses,
  GetUsersFeedData,
  GetUsersFeedMatchesData,
  GetUsersFeedMatchesResponses,
  GetUsersFeedNewsData,
  GetUsersFeedNewsResponses,
  GetUsersFeedOffersData,
  GetUsersFeedOffersResponses,
  GetUsersFeedPostsData,
  GetUsersFeedPostsResponses,
  GetUsersFeedResponses,
  GetUsersFollowersListByIdData,
  GetUsersFollowersListByIdResponses,
  GetUsersMessagesCounterpartsData,
  GetUsersMessagesCounterpartsResponses,
  GetUsersNotificationsData,
  GetUsersNotificationsDropdownData,
  GetUsersNotificationsDropdownResponses,
  GetUsersNotificationsResponses,
  GetUsersPreferredSurfacesData,
  GetUsersPreferredSurfacesResponses,
  GetUsersTeacherQualificationsData,
  GetUsersTeacherQualificationsResponses,
  GetUsersTrainerQualificationsData,
  GetUsersTrainerQualificationsResponses,
  GetUsersUserMatchesData,
  GetUsersUserMatchesResponses,
  PatchCustomBannersByIdData,
  PatchCustomBannersByIdErrors,
  PatchCustomBannersByIdResponses,
  PatchMatchesByIdData,
  PatchMatchesByIdErrors,
  PatchMatchesByIdResponses,
  PatchOffersByIdData,
  PatchOffersByIdErrors,
  PatchOffersByIdResponses,
  PatchPostsByPostIdCommentsByIdData,
  PatchPostsByPostIdCommentsByIdResponses,
  PostBonusesData,
  PostBonusesErrors,
  PostBonusesResponses,
  PostCardinalitySaveData,
  PostCardinalitySaveResponses,
  PostCommentsByIdLikeData,
  PostCommentsByIdLikeErrors,
  PostCommentsByIdLikeResponses,
  PostCompetitionsAdvancedSearchData,
  PostCompetitionsAdvancedSearchResponses,
  PostContactsData,
  PostContactsResponses,
  PostCustomBannersData,
  PostCustomBannersResponses,
  PostEditProfileAppTokenInfoData,
  PostEditProfileAppTokenInfoErrors,
  PostEndorsementsData,
  PostEndorsementsResponses,
  PostFitPlayerProfilesAdvancedSearchData,
  PostFitPlayerProfilesAdvancedSearchErrors,
  PostFitPlayerProfilesAdvancedSearchResponses,
  PostFitPlayerProfilesCheckFitCardNumberData,
  PostFitPlayerProfilesCheckFitCardNumberResponses,
  PostFollowsData,
  PostFollowsResponses,
  PostHomeInlineSearchData,
  PostHomeInlineSearchPlayersData,
  PostHomeInlineSearchPlayersResponses,
  PostHomeInlineSearchResponses,
  PostHomeInvitationData,
  PostHomeInvitationResponses,
  PostHomeSendAllNotificationsData,
  PostHomeSendAllNotificationsResponses,
  PostMatchesData,
  PostMatchesResponses,
  PostMessagesData,
  PostMessagesResponses,
  PostOffersData,
  PostOffersErrors,
  PostOffersResponses,
  PostOffersSearchData,
  PostOffersSearchResponses,
  PostPositionedBannersData,
  PostPositionedBannersResponses,
  PostPostsByIdLikeData,
  PostPostsByIdLikeErrors,
  PostPostsByIdLikeResponses,
  PostPostsByPostIdCommentsData,
  PostPostsByPostIdCommentsResponses,
  PostPostsData,
  PostPostsErrors,
  PostPostsResponses,
  PostPremiumTokensData,
  PostPremiumTokensMembershipEmailData,
  PostPremiumTokensMembershipEmailResponses,
  PostPremiumTokensResponses,
  PostRemoveFollowData,
  PostRemoveFollowErrors,
  PostRemoveFollowResponses,
  PostSavedCompetitionSearchData,
  PostSavedCompetitionSearchErrors,
  PostSavedCompetitionSearchResponses,
  PostSearchClubsData,
  PostSearchClubsResponses,
  PostSearchCompetitionsData,
  PostSearchCompetitionsResponses,
  PostSearchOtherProfilesData,
  PostSearchOtherProfilesResponses,
  PostSearchPlayersData,
  PostSearchPlayersResponses,
  PostSessionsAppleWebAuthData,
  PostSessionsAppleWebAuthResponses,
  PostSessionsBackofficeData,
  PostSessionsBackofficeResponses,
  PostSessionsData,
  PostSessionsFacebookData,
  PostSessionsFacebookLimitedData,
  PostSessionsFacebookLimitedResponses,
  PostSessionsFacebookResponses,
  PostSessionsResponses,
  PostShopifyOrderData,
  PostShopifyOrderErrors,
  PostShopifyOrderResponses,
  PostUpdateTasksCacheRefreshData,
  PostUpdateTasksCacheRefreshResponses,
  PostUpdateTasksData,
  PostUpdateTasksResponses,
  PostUpdateTasksRestartServersData,
  PostUpdateTasksRestartServersResponses,
  PostUpdateTasksRunAsyncJobData,
  PostUpdateTasksRunAsyncJobErrors,
  PostUpdateTasksRunAsyncJobResponses,
  PostUpdateTasksRunRestoreDumpData,
  PostUpdateTasksRunRestoreDumpResponses,
  PostUserMatchesData,
  PostUserMatchesResponses,
  PostUsersAccountConfirmationEmailData,
  PostUsersAccountConfirmationEmailResponses,
  PostUsersCheckFitClubIdData,
  PostUsersCheckFitClubIdResponses,
  PostUsersCompleteProfileData,
  PostUsersCompleteProfileErrors,
  PostUsersCompleteProfileResponses,
  PostUsersMarketData,
  PostUsersMarketResponses,
  PostUsersSignUpAdditionalInfoData,
  PostUsersSignUpAdditionalInfoErrors,
  PostUsersSignUpAdditionalInfoResponses,
  PostUsersSignUpData,
  PostUsersSignUpResponses,
  PutCustomBannersByIdData,
  PutCustomBannersByIdErrors,
  PutCustomBannersByIdResponses,
  PutDrawsByIdChangeBestLoserRankingData,
  PutDrawsByIdChangeBestLoserRankingErrors,
  PutDrawsByIdChangeBestLoserRankingResponses,
  PutDrawsByIdChangeWinnerData,
  PutDrawsByIdChangeWinnerErrors,
  PutDrawsByIdChangeWinnerResponses,
  PutDrawsByIdDeleteMatchesData,
  PutDrawsByIdDeleteMatchesErrors,
  PutDrawsByIdDeleteMatchesResponses,
  PutEditProfileAccountInfoData,
  PutEditProfileAccountInfoErrors,
  PutEditProfileAccountInfoResponses,
  PutEditProfileAppTokenInfoData,
  PutEditProfileAppTokenInfoErrors,
  PutEditProfileAppTokenInfoResponses,
  PutEditProfileDeleteProfileData,
  PutEditProfileDeleteProfileErrors,
  PutEditProfileDeleteProfileResponses,
  PutEditProfileGeneralInfoData,
  PutEditProfileGeneralInfoErrors,
  PutEditProfileGeneralInfoResponses,
  PutEditProfileProfilesInfoData,
  PutEditProfileProfilesInfoErrors,
  PutEditProfileProfilesInfoResponses,
  PutEditProfileRemovePlayerProfileAssociationsData,
  PutEditProfileRemovePlayerProfileAssociationsErrors,
  PutEditProfileRemovePlayerProfileAssociationsResponses,
  PutEditProfileRemovePlayerProfileData,
  PutEditProfileRemovePlayerProfileErrors,
  PutEditProfileRemovePlayerProfileResponses,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData,
  PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses,
  PutMatchesByIdData,
  PutMatchesByIdErrors,
  PutMatchesByIdResponses,
  PutMatchesByIdResultData,
  PutMatchesByIdResultErrors,
  PutMatchesByIdResultResponses,
  PutMessagesByIdBlockData,
  PutMessagesByIdBlockResponses,
  PutOffersByIdData,
  PutOffersByIdResponses,
  PutPositionedBannersByIdData,
  PutPositionedBannersByIdResponses,
  PutPremiumTokensByIdData,
  PutPremiumTokensByIdErrors,
  PutPremiumTokensByIdResponses,
  PutResetPasswordData,
  PutResetPasswordRequestData,
  PutResetPasswordRequestResponses,
  PutResetPasswordResponses,
  PutUpdateTasksByIdRunData,
  PutUpdateTasksByIdRunResponses,
  PutUpdateTasksByIdSetPendingData,
  PutUpdateTasksByIdSetPendingResponses,
  PutUserMatchesByIdConfirmData,
  PutUserMatchesByIdConfirmErrors,
  PutUserMatchesByIdConfirmResponses,
  PutUserMatchesByIdData,
  PutUserMatchesByIdErrors,
  PutUserMatchesByIdRejectData,
  PutUserMatchesByIdRejectErrors,
  PutUserMatchesByIdRejectResponses,
  PutUserMatchesByIdResponses,
  PutUserMatchesByIdResultData,
  PutUserMatchesByIdResultErrors,
  PutUserMatchesByIdResultResponses,
  PutUsersMarketConditionAcceptedData,
  PutUsersMarketConditionAcceptedResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Logs out a user
 */
export const deleteSessionsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSessionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteSessionsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/{id}',
    ...options,
  });

/**
 * Logs in a user with Facebook
 */
export const postSessionsFacebook = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsFacebookData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSessionsFacebookResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/facebook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Logs in a user with Facebook with JWT instead of old normal token
 */
export const postSessionsFacebookLimited = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsFacebookLimitedData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSessionsFacebookLimitedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/facebook_limited',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Logs in a user with Apple (web)
 */
export const postSessionsAppleWebAuth = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsAppleWebAuthData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSessionsAppleWebAuthResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/apple-web-auth',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Logs in a backoffice user
 */
export const postSessionsBackoffice = <ThrowOnError extends boolean = false>(
  options?: Options<PostSessionsBackofficeData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSessionsBackofficeResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions/backoffice',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Tests login check
 */
export const getFakeRouteToTestLoginCheck = <ThrowOnError extends boolean = false>(
  options?: Options<GetFakeRouteToTestLoginCheckData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFakeRouteToTestLoginCheckResponses,
    GetFakeRouteToTestLoginCheckErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fake-route-to-test-login-check',
    ...options,
  });

/**
 * Mostra i dettagli di un club
 */
export const getClubsById = <ThrowOnError extends boolean = false>(options: Options<GetClubsByIdData, ThrowOnError>) =>
  (options.client ?? client).get<GetClubsByIdResponses, GetClubsByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/{id}',
    ...options,
  });

/**
 * Restituisce il feed di un club
 */
export const getClubsByIdFeed = <ThrowOnError extends boolean = false>(
  options: Options<GetClubsByIdFeedData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetClubsByIdFeedResponses, GetClubsByIdFeedErrors, ThrowOnError>({
    responseTransformer: getClubsByIdFeedResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/{id}/feed',
    ...options,
  });

/**
 * Restituisce l'ID del club dato un fit_club_id
 */
export const getClubsIdByFitClubIdByFitClubId = <ThrowOnError extends boolean = false>(
  options: Options<GetClubsIdByFitClubIdByFitClubIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetClubsIdByFitClubIdByFitClubIdResponses,
    GetClubsIdByFitClubIdByFitClubIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/clubs/id-by-fit-club-id/{fit_club_id}',
    ...options,
  });

/**
 * Mette like a un commento
 */
export const postCommentsByIdLike = <ThrowOnError extends boolean = false>(
  options: Options<PostCommentsByIdLikeData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostCommentsByIdLikeResponses, PostCommentsByIdLikeErrors, ThrowOnError>({
    responseTransformer: postCommentsByIdLikeResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/comments/{id}/like',
    ...options,
  });

/**
 * Rimuove il like da un commento
 */
export const deleteCommentsByIdUnlike = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCommentsByIdUnlikeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteCommentsByIdUnlikeResponses, DeleteCommentsByIdUnlikeErrors, ThrowOnError>({
    responseTransformer: deleteCommentsByIdUnlikeResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/comments/{id}/unlike',
    ...options,
  });

/**
 * Mostra i dettagli di una competizione
 */
export const getCompetitionsById = <ThrowOnError extends boolean = false>(
  options: Options<GetCompetitionsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCompetitionsByIdResponses, GetCompetitionsByIdErrors, ThrowOnError>({
    url: '/competitions/{id}',
    ...options,
  });

/**
 * Ricerca competizioni per query
 */
export const getCompetitionsSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetCompetitionsSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCompetitionsSearchResponses, unknown, ThrowOnError>({
    url: '/competitions/search',
    ...options,
  });

/**
 * Ricerca avanzata competizioni
 */
export const postCompetitionsAdvancedSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostCompetitionsAdvancedSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostCompetitionsAdvancedSearchResponses, unknown, ThrowOnError>({
    url: '/competitions/advanced-search',
    ...options,
  });

/**
 * Elimina un tabellone (draw) e i suoi match
 */
export const deleteDrawsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDrawsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteDrawsByIdResponses, DeleteDrawsByIdErrors, ThrowOnError>({
    url: '/draws/{id}',
    ...options,
  });

/**
 * Mostra un tabellone (draw)
 */
export const getDrawsById = <ThrowOnError extends boolean = false>(options: Options<GetDrawsByIdData, ThrowOnError>) =>
  (options.client ?? client).get<GetDrawsByIdResponses, GetDrawsByIdErrors, ThrowOnError>({
    url: '/draws/{id}',
    ...options,
  });

/**
 * Elimina tutti i match di un tabellone
 */
export const putDrawsByIdDeleteMatches = <ThrowOnError extends boolean = false>(
  options: Options<PutDrawsByIdDeleteMatchesData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutDrawsByIdDeleteMatchesResponses, PutDrawsByIdDeleteMatchesErrors, ThrowOnError>({
    url: '/draws/{id}/delete-matches',
    ...options,
  });

/**
 * Cambia il vincitore di un tabellone
 */
export const putDrawsByIdChangeWinner = <ThrowOnError extends boolean = false>(
  options: Options<PutDrawsByIdChangeWinnerData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutDrawsByIdChangeWinnerResponses, PutDrawsByIdChangeWinnerErrors, ThrowOnError>({
    url: '/draws/{id}/change-winner',
    ...options,
  });

/**
 * Cambia il best loser ranking di un tabellone
 */
export const putDrawsByIdChangeBestLoserRanking = <ThrowOnError extends boolean = false>(
  options: Options<PutDrawsByIdChangeBestLoserRankingData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutDrawsByIdChangeBestLoserRankingResponses,
    PutDrawsByIdChangeBestLoserRankingErrors,
    ThrowOnError
  >({ url: '/draws/{id}/change-best-loser-ranking', ...options });

/**
 * Restituisce i profili dell'utente
 */
export const getEditProfileProfiles = <ThrowOnError extends boolean = false>(
  options: Options<GetEditProfileProfilesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetEditProfileProfilesResponses, GetEditProfileProfilesErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/profiles',
    ...options,
  });

/**
 * Aggiorna le informazioni generali dell'utente
 */
export const putEditProfileGeneralInfo = <ThrowOnError extends boolean = false>(
  options?: Options<PutEditProfileGeneralInfoData, ThrowOnError>,
) =>
  (options?.client ?? client).put<PutEditProfileGeneralInfoResponses, PutEditProfileGeneralInfoErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/general-info',
    ...options,
  });

/**
 * Aggiorna le informazioni account dell'utente
 */
export const putEditProfileAccountInfo = <ThrowOnError extends boolean = false>(
  options?: Options<PutEditProfileAccountInfoData, ThrowOnError>,
) =>
  (options?.client ?? client).put<PutEditProfileAccountInfoResponses, PutEditProfileAccountInfoErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/account-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Aggiorna le informazioni dei profili secondari
 */
export const putEditProfileProfilesInfo = <ThrowOnError extends boolean = false>(
  options?: Options<PutEditProfileProfilesInfoData, ThrowOnError>,
) =>
  (options?.client ?? client).put<PutEditProfileProfilesInfoResponses, PutEditProfileProfilesInfoErrors, ThrowOnError>({
    querySerializer: { parameters: { teacher_profile: { object: { style: 'form' } } } },
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/profiles-info',
    ...options,
  });

/**
 * Gestisce il token dell'app
 */
export const postEditProfileAppTokenInfo = <ThrowOnError extends boolean = false>(
  options: Options<PostEditProfileAppTokenInfoData, ThrowOnError>,
) =>
  (options.client ?? client).post<unknown, PostEditProfileAppTokenInfoErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/app-token-info',
    ...options,
  });

/**
 * update app token info
 */
export const putEditProfileAppTokenInfo = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileAppTokenInfoData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutEditProfileAppTokenInfoResponses, PutEditProfileAppTokenInfoErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/app-token-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Elimina un profilo secondario
 */
export const putEditProfileDeleteProfile = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileDeleteProfileData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutEditProfileDeleteProfileResponses, PutEditProfileDeleteProfileErrors, ThrowOnError>(
    {
      security: [{ name: 'X-Api-Key', type: 'apiKey' }],
      url: '/edit-profile/delete-profile',
      ...options,
    },
  );

/**
 * Rimuove il profilo giocatore dell'utente corrente
 */
export const putEditProfileRemovePlayerProfile = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileRemovePlayerProfileData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutEditProfileRemovePlayerProfileResponses,
    PutEditProfileRemovePlayerProfileErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/remove-player-profile',
    ...options,
  });

/**
 * Rimuove le associazioni del profilo giocatore
 */
export const putEditProfileRemovePlayerProfileAssociations = <ThrowOnError extends boolean = false>(
  options: Options<PutEditProfileRemovePlayerProfileAssociationsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutEditProfileRemovePlayerProfileAssociationsResponses,
    PutEditProfileRemovePlayerProfileAssociationsErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/edit-profile/remove-player-profile-associations',
    ...options,
  });

/**
 * Mostra il profilo FIT di un giocatore
 */
export const getFitPlayerProfilesById = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdResponses, GetFitPlayerProfilesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}',
    ...options,
  });

/**
 * Get fit player profile wrapped data
 */
export const getFitPlayerProfilesByIdWrapped = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdWrappedData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdWrappedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/wrapped',
    ...options,
  });

/**
 * Ricerca profili FIT
 */
export const getFitPlayerProfilesSearch = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesSearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesSearchResponses, unknown, ThrowOnError>({
    url: '/fit-player-profiles/search',
    ...options,
  });

/**
 * Ricerca avanzata profili FIT
 */
export const postFitPlayerProfilesAdvancedSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostFitPlayerProfilesAdvancedSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostFitPlayerProfilesAdvancedSearchResponses,
    PostFitPlayerProfilesAdvancedSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/advanced-search',
    ...options,
  });

/**
 * Restituisce i filtri per la ricerca avanzata
 */
export const getFitPlayerProfilesAdvancedSearchFilters = <ThrowOnError extends boolean = false>(
  options?: Options<GetFitPlayerProfilesAdvancedSearchFiltersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFitPlayerProfilesAdvancedSearchFiltersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/advanced-search/filters',
    ...options,
  });

/**
 * Restituisce il rank attuale del profilo FIT
 */
export const getFitPlayerProfilesByIdRank = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdRankData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdRankResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/rank',
    ...options,
  });

/**
 * Restituisce le statistiche del profilo FIT
 */
export const getFitPlayerProfilesByIdStats = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdStatsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdStatsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/stats',
    ...options,
  });

/**
 * Simulatore ranking per il profilo FIT
 */
export const getFitPlayerProfilesByIdSimulator = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdSimulatorData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdSimulatorResponses,
    GetFitPlayerProfilesByIdSimulatorErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/simulator',
    ...options,
  });

/**
 * Restituisce la harmonization del profilo FIT
 */
export const getFitPlayerProfilesByIdHarmonization = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdHarmonizationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFitPlayerProfilesByIdHarmonizationResponses,
    GetFitPlayerProfilesByIdHarmonizationErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/harmonization',
    ...options,
  });

/**
 * Restituisce gli endorsement del profilo FIT
 */
export const getFitPlayerProfilesByIdEndorsements = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdEndorsementsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdEndorsementsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/endorsements',
    ...options,
  });

/**
 * Restituisce il numero di visite del profilo FIT
 */
export const getFitPlayerProfilesByIdVisits = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdVisitsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdVisitsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/visits',
    ...options,
  });

/**
 * Restituisce il feed del profilo FIT
 */
export const getFitPlayerProfilesByIdFeed = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdFeedData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdFeedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/feed',
    ...options,
  });

/**
 * Restituisce i visitatori del profilo FIT
 */
export const getFitPlayerProfilesByIdVisitors = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdVisitorsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdVisitorsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/visitors',
    ...options,
  });

/**
 * Get player followers list
 */
export const getFitPlayerProfilesFollowersListById = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesFollowersListByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesFollowersListByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/followers_list/{id}',
    ...options,
  });

/**
 * Restituisce le info utente collegate al profilo FIT
 */
export const getFitPlayerProfilesByIdUserInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdUserInfoData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdUserInfoResponses, unknown, ThrowOnError>({
    url: '/fit-player-profiles/{id}/user-info',
    ...options,
  });

/**
 * Mostra il profilo FIT ridotto (per crawler)
 */
export const getFitPlayerProfilesByIdReduced = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesByIdReducedData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesByIdReducedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/{id}/reduced',
    ...options,
  });

/**
 * Restituisce i profili FIT più visitati
 */
export const getFitPlayerProfilesMostVisited = <ThrowOnError extends boolean = false>(
  options?: Options<GetFitPlayerProfilesMostVisitedData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFitPlayerProfilesMostVisitedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/most_visited',
    ...options,
  });

/**
 * Controlla la validità di un fit_card_number
 */
export const postFitPlayerProfilesCheckFitCardNumber = <ThrowOnError extends boolean = false>(
  options: Options<PostFitPlayerProfilesCheckFitCardNumberData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostFitPlayerProfilesCheckFitCardNumberResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/check-fit-card-number',
    ...options,
  });

/**
 * Restituisce l'ID dato un numero di tessera
 */
export const getFitPlayerProfilesCardToIdByCardNumber = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesCardToIdByCardNumberData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFitPlayerProfilesCardToIdByCardNumberResponses,
    GetFitPlayerProfilesCardToIdByCardNumberErrors,
    ThrowOnError
  >({ url: '/fit-player-profiles/card-to-id/{card_number}', ...options });

/**
 * Search players for merging
 */
export const getFitPlayerProfilesSearchForMerge = <ThrowOnError extends boolean = false>(
  options?: Options<GetFitPlayerProfilesSearchForMergeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFitPlayerProfilesSearchForMergeResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/search-for-merge',
    ...options,
  });

/**
 * Effettua il merge tra due profili
 */
export const putFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerId = <ThrowOnError extends boolean = false>(
  options: Options<PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    PutFitPlayerProfilesMergeBySourcePlayerIdByDestinationPlayerIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/merge/{source_player_id}/{destination_player_id}',
    ...options,
  });

/**
 * Restituisce la home con post e magazine
 */
export const getHome = <ThrowOnError extends boolean = false>(options?: Options<GetHomeData, ThrowOnError>) =>
  (options?.client ?? client).get<GetHomeResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home',
    ...options,
  });

/**
 * Restituisce i numeri principali della piattaforma
 */
export const getHomeNumbers = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeNumbersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHomeNumbersResponses, unknown, ThrowOnError>({ url: '/home/numbers', ...options });

/**
 * Restituisce le notifiche non lette dell'utente
 */
export const getHomeNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeNotificationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHomeNotificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/notifications',
    ...options,
  });

/**
 * Restituisce i numeri per il backoffice
 */
export const getHomeBackofficeNumbers = <ThrowOnError extends boolean = false>(
  options?: Options<GetHomeBackofficeNumbersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHomeBackofficeNumbersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/backoffice_numbers',
    ...options,
  });

/**
 * Ricerca rapida globale
 */
export const postHomeInlineSearch = <ThrowOnError extends boolean = false>(
  options: Options<PostHomeInlineSearchData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostHomeInlineSearchResponses, unknown, ThrowOnError>({
    url: '/home/inline-search',
    ...options,
  });

/**
 * Ricerca rapida giocatori
 */
export const postHomeInlineSearchPlayers = <ThrowOnError extends boolean = false>(
  options: Options<PostHomeInlineSearchPlayersData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostHomeInlineSearchPlayersResponses, unknown, ThrowOnError>({
    url: '/home/inline-search-players',
    ...options,
  });

/**
 * Invia un invito tramite email
 */
export const postHomeInvitation = <ThrowOnError extends boolean = false>(
  options: Options<PostHomeInvitationData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostHomeInvitationResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/invitation',
    ...options,
  });

/**
 * Restituisce il rate della piattaforma
 */
export const getHomeRate = <ThrowOnError extends boolean = false>(options?: Options<GetHomeRateData, ThrowOnError>) =>
  (options?.client ?? client).get<GetHomeRateResponses, unknown, ThrowOnError>({ url: '/home/rate', ...options });

/**
 * Invia una notifica a tutti gli utenti
 */
export const postHomeSendAllNotifications = <ThrowOnError extends boolean = false>(
  options: Options<PostHomeSendAllNotificationsData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostHomeSendAllNotificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/home/send_all_notifications',
    ...options,
  });

/**
 * Mette like a un post
 */
export const postPostsByIdLike = <ThrowOnError extends boolean = false>(
  options: Options<PostPostsByIdLikeData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostPostsByIdLikeResponses, PostPostsByIdLikeErrors, ThrowOnError>({
    responseTransformer: postPostsByIdLikeResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}/like',
    ...options,
  });

/**
 * Rimuove il like da un post
 */
export const deletePostsByIdUnlike = <ThrowOnError extends boolean = false>(
  options: Options<DeletePostsByIdUnlikeData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeletePostsByIdUnlikeResponses, DeletePostsByIdUnlikeErrors, ThrowOnError>({
    responseTransformer: deletePostsByIdUnlikeResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{id}/unlike',
    ...options,
  });

/**
 * Lista dei match
 */
export const getMatches = <ThrowOnError extends boolean = false>(options?: Options<GetMatchesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches',
    ...options,
  });

/**
 * Crea un nuovo match
 */
export const postMatches = <ThrowOnError extends boolean = false>(options?: Options<PostMatchesData, ThrowOnError>) =>
  (options?.client ?? client).post<PostMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un match
 */
export const deleteMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteMatchesByIdResponses, DeleteMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches/{id}',
    ...options,
  });

/**
 * Mostra un match
 */
export const getMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<GetMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetMatchesByIdResponses, GetMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches/{id}',
    ...options,
  });

/**
 * Aggiorna un match
 */
export const patchMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<PatchMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PatchMatchesByIdResponses, PatchMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Aggiorna un match
 */
export const putMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<PutMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutMatchesByIdResponses, PutMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Aggiorna solo il risultato di un match
 */
export const putMatchesByIdResult = <ThrowOnError extends boolean = false>(
  options: Options<PutMatchesByIdResultData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutMatchesByIdResultResponses, PutMatchesByIdResultErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/matches/{id}/result',
    ...options,
  });

/**
 * Delete offer
 */
export const deleteOffersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteOffersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteOffersByIdResponses, DeleteOffersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
  });

/**
 * Get offer details
 */
export const getOffersById = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetOffersByIdResponses, GetOffersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
  });

/**
 * Update offer
 */
export const patchOffersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchOffersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PatchOffersByIdResponses, PatchOffersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update offer
 */
export const putOffersById = <ThrowOnError extends boolean = false>(
  options: Options<PutOffersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutOffersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search offers
 */
export const postOffersSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostOffersSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostOffersSearchResponses, unknown, ThrowOnError>({
    url: '/offers/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Get private offers
 */
export const getOffersPrivates = <ThrowOnError extends boolean = false>(
  options?: Options<GetOffersPrivatesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetOffersPrivatesResponses, GetOffersPrivatesErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/privates',
    ...options,
  });

/**
 * Get shop offers
 */
export const getOffersShops = <ThrowOnError extends boolean = false>(
  options: Options<GetOffersShopsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetOffersShopsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers/shops',
    ...options,
  });

/**
 * Create offer
 */
export const postOffers = <ThrowOnError extends boolean = false>(options?: Options<PostOffersData, ThrowOnError>) =>
  (options?.client ?? client).post<PostOffersResponses, PostOffersErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/offers',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Creates a new post
 */
export const postPosts = <ThrowOnError extends boolean = false>(options?: Options<PostPostsData, ThrowOnError>) =>
  (options?.client ?? client).post<PostPostsResponses, PostPostsErrors, ThrowOnError>({
    responseTransformer: postPostsResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * user registration
 */
export const postUsersSignUp = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersSignUpData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUsersSignUpResponses, unknown, ThrowOnError>({
    url: '/users/sign-up',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * update user additional information
 */
export const postUsersSignUpAdditionalInfo = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersSignUpAdditionalInfoData, ThrowOnError>,
) =>
  (options?.client ?? client).post<
    PostUsersSignUpAdditionalInfoResponses,
    PostUsersSignUpAdditionalInfoErrors,
    ThrowOnError
  >({
    url: '/users/sign-up/additional-info',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * complete user profile with professional profiles
 */
export const postUsersCompleteProfile = <ThrowOnError extends boolean = false>(
  options?: Options<PostUsersCompleteProfileData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUsersCompleteProfileResponses, PostUsersCompleteProfileErrors, ThrowOnError>({
    url: '/users/complete-profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Ricerca giocatori
 */
export const postSearchPlayers = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchPlayersData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSearchPlayersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/players',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Ricerca club
 */
export const postSearchClubs = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchClubsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSearchClubsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/clubs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Ricerca competizioni
 */
export const postSearchCompetitions = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchCompetitionsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSearchCompetitionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/competitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Ricerca altri profili
 */
export const postSearchOtherProfiles = <ThrowOnError extends boolean = false>(
  options?: Options<PostSearchOtherProfilesData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSearchOtherProfilesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/search/other_profiles',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Logs in a user with email and password
 */
export const postSessions = <ThrowOnError extends boolean = false>(options?: Options<PostSessionsData, ThrowOnError>) =>
  (options?.client ?? client).post<PostSessionsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Receive order webhook from Shopify
 */
export const postShopifyOrder = <ThrowOnError extends boolean = false>(
  options: Options<PostShopifyOrderData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostShopifyOrderResponses, PostShopifyOrderErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/shopify/order',
    ...options,
  });

/**
 * Get tournament details
 */
export const getTournamentsById = <ThrowOnError extends boolean = false>(
  options: Options<GetTournamentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetTournamentsByIdResponses, GetTournamentsByIdErrors, ThrowOnError>({
    url: '/tournaments/{id}',
    ...options,
  });

/**
 * get user by id
 */
export const getUsersById = <ThrowOnError extends boolean = false>(options: Options<GetUsersByIdData, ThrowOnError>) =>
  (options.client ?? client).get<GetUsersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}',
    ...options,
  });

/**
 * get user posts
 */
export const getUsersByIdPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdPostsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersByIdPostsResponses, unknown, ThrowOnError>({
    responseTransformer: getUsersByIdPostsResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/posts',
    ...options,
  });

/**
 * get user preview
 */
export const getUsersByIdPreview = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByIdPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersByIdPreviewResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{id}/preview',
    ...options,
  });

/**
 * get user notifications
 */
export const getUsersNotifications = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersNotificationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersNotificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/notifications',
    ...options,
  });

/**
 * get user notifications dropdown
 */
export const getUsersNotificationsDropdown = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersNotificationsDropdownData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersNotificationsDropdownResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/notifications_dropdown',
    ...options,
  });

/**
 * get user followers list
 */
export const getUsersFollowersListById = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFollowersListByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFollowersListByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/followers_list/{id}',
    ...options,
  });

/**
 * get preferred surfaces
 */
export const getUsersPreferredSurfaces = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersPreferredSurfacesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUsersPreferredSurfacesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/preferred_surfaces',
    ...options,
  });

/**
 * get teacher qualifications
 */
export const getUsersTeacherQualifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersTeacherQualificationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUsersTeacherQualificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/teacher_qualifications',
    ...options,
  });

/**
 * get trainer qualifications
 */
export const getUsersTrainerQualifications = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsersTrainerQualificationsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUsersTrainerQualificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/trainer_qualifications',
    ...options,
  });

/**
 * get facebook info by token
 */
export const getUsersFacebookInfoByToken = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFacebookInfoByTokenData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFacebookInfoByTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/facebook-info/{token}',
    ...options,
  });

/**
 * confirm user account
 */
export const getUsersConfirmAccountByToken = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersConfirmAccountByTokenData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersConfirmAccountByTokenResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/confirm-account/{token}',
    ...options,
  });

/**
 * send account confirmation email
 */
export const postUsersAccountConfirmationEmail = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersAccountConfirmationEmailData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostUsersAccountConfirmationEmailResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/account-confirmation-email',
    ...options,
  });

/**
 * get fit player id by token
 */
export const getUsersByTokenFitPlayerId = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersByTokenFitPlayerIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersByTokenFitPlayerIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/{token}/fit-player-id',
    ...options,
  });

/**
 * get user feed
 */
export const getUsersFeed = <ThrowOnError extends boolean = false>(options: Options<GetUsersFeedData, ThrowOnError>) =>
  (options.client ?? client).get<GetUsersFeedResponses, unknown, ThrowOnError>({
    responseTransformer: getUsersFeedResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed',
    ...options,
  });

/**
 * get user feed posts
 */
export const getUsersFeedPosts = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedPostsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFeedPostsResponses, unknown, ThrowOnError>({
    responseTransformer: getUsersFeedPostsResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-posts',
    ...options,
  });

/**
 * get user feed matches
 */
export const getUsersFeedMatches = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedMatchesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFeedMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-matches',
    ...options,
  });

/**
 * get user feed offers
 */
export const getUsersFeedOffers = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedOffersData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFeedOffersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-offers',
    ...options,
  });

/**
 * get news feed
 */
export const getUsersFeedNews = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersFeedNewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersFeedNewsResponses, unknown, ThrowOnError>({
    responseTransformer: getUsersFeedNewsResponseTransformer,
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/feed-news',
    ...options,
  });

/**
 * get user market offers
 */
export const postUsersMarket = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersMarketData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostUsersMarketResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/market',
    ...options,
  });

/**
 * get user matches
 */
export const getUsersUserMatches = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersUserMatchesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersUserMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/user-matches',
    ...options,
  });

/**
 * accept market conditions
 */
export const putUsersMarketConditionAccepted = <ThrowOnError extends boolean = false>(
  options: Options<PutUsersMarketConditionAcceptedData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUsersMarketConditionAcceptedResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/market-condition-accepted',
    ...options,
  });

/**
 * check fit club id
 */
export const postUsersCheckFitClubId = <ThrowOnError extends boolean = false>(
  options: Options<PostUsersCheckFitClubIdData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostUsersCheckFitClubIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/check-fit-club-id',
    ...options,
  });

/**
 * Lista i bonus del profilo giocatore corrente
 */
export const getBonuses = <ThrowOnError extends boolean = false>(options?: Options<GetBonusesData, ThrowOnError>) =>
  (options?.client ?? client).get<GetBonusesResponses, GetBonusesErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses',
    ...options,
  });

/**
 * Crea un nuovo bonus per il profilo giocatore corrente
 */
export const postBonuses = <ThrowOnError extends boolean = false>(options?: Options<PostBonusesData, ThrowOnError>) =>
  (options?.client ?? client).post<PostBonusesResponses, PostBonusesErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un bonus dal profilo giocatore corrente
 */
export const deleteBonusesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteBonusesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteBonusesByIdResponses, DeleteBonusesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/bonuses/{id}',
    ...options,
  });

/**
 * Crea un nuovo commento su un post
 */
export const postPostsByPostIdComments = <ThrowOnError extends boolean = false>(
  options: Options<PostPostsByPostIdCommentsData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostPostsByPostIdCommentsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Elimina un commento
 */
export const deletePostsByPostIdCommentsById = <ThrowOnError extends boolean = false>(
  options: Options<DeletePostsByPostIdCommentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeletePostsByPostIdCommentsByIdResponses,
    DeletePostsByPostIdCommentsByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments/{id}',
    ...options,
  });

/**
 * Aggiorna un commento
 */
export const patchPostsByPostIdCommentsById = <ThrowOnError extends boolean = false>(
  options: Options<PatchPostsByPostIdCommentsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PatchPostsByPostIdCommentsByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/posts/{post_id}/comments/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Invia una richiesta di contatto
 */
export const postContacts = <ThrowOnError extends boolean = false>(options?: Options<PostContactsData, ThrowOnError>) =>
  (options?.client ?? client).post<PostContactsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/contacts',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Restituisce tutti i custom banners
 */
export const getCustomBannersAll = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomBannersAllData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCustomBannersAllResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/all',
    ...options,
  });

/**
 * Restituisce i custom banners paginati
 */
export const getCustomBanners = <ThrowOnError extends boolean = false>(
  options?: Options<GetCustomBannersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCustomBannersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners',
    ...options,
  });

/**
 * Crea un nuovo custom banner
 */
export const postCustomBanners = <ThrowOnError extends boolean = false>(
  options?: Options<PostCustomBannersData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostCustomBannersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un custom banner
 */
export const deleteCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCustomBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteCustomBannersByIdResponses, DeleteCustomBannersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
  });

/**
 * Mostra un custom banner
 */
export const getCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<GetCustomBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCustomBannersByIdResponses, GetCustomBannersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
  });

/**
 * Aggiorna un custom banner
 */
export const patchCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PatchCustomBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).patch<PatchCustomBannersByIdResponses, PatchCustomBannersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Aggiorna un custom banner
 */
export const putCustomBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PutCustomBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutCustomBannersByIdResponses, PutCustomBannersByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/custom_banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Crea un endorsement
 */
export const postEndorsements = <ThrowOnError extends boolean = false>(
  options?: Options<PostEndorsementsData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostEndorsementsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/endorsements',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un endorsement
 */
export const deleteEndorsementsById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteEndorsementsByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteEndorsementsByIdResponses, DeleteEndorsementsByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/endorsements/{id}',
    ...options,
  });

/**
 * Restituisce le news del feed
 */
export const getFeedNews = <ThrowOnError extends boolean = false>(options?: Options<GetFeedNewsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetFeedNewsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/feed_news',
    ...options,
  });

/**
 * Restituisce la lista delle richieste di profilo FIT
 */
export const getFitPlayerProfileRequests = <ThrowOnError extends boolean = false>(
  options?: Options<GetFitPlayerProfileRequestsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFitPlayerProfileRequestsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profile-requests',
    ...options,
  });

/**
 * Ricerca profili per merge
 */
export const getFitPlayerProfilesSearchForMergeByQ = <ThrowOnError extends boolean = false>(
  options: Options<GetFitPlayerProfilesSearchForMergeByQData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFitPlayerProfilesSearchForMergeByQResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/fit-player-profiles/search-for-merge/{q}',
    ...options,
  });

/**
 * Crea un follow
 */
export const postFollows = <ThrowOnError extends boolean = false>(options: Options<PostFollowsData, ThrowOnError>) =>
  (options.client ?? client).post<PostFollowsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/follows',
    ...options,
  });

/**
 * Rimuove un follow
 */
export const postRemoveFollow = <ThrowOnError extends boolean = false>(
  options: Options<PostRemoveFollowData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostRemoveFollowResponses, PostRemoveFollowErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/remove-follow',
    ...options,
  });

/**
 * Restituisce la conversazione tra due profili
 */
export const getMessagesConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetMessagesConversationData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetMessagesConversationResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages/conversation',
    ...options,
  });

/**
 * Crea un nuovo messaggio
 */
export const postMessages = <ThrowOnError extends boolean = false>(options?: Options<PostMessagesData, ThrowOnError>) =>
  (options?.client ?? client).post<PostMessagesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Blocca un messaggio
 */
export const putMessagesByIdBlock = <ThrowOnError extends boolean = false>(
  options: Options<PutMessagesByIdBlockData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutMessagesByIdBlockResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/messages/{id}/block',
    ...options,
  });

/**
 * Restituisce i profili con cui l'utente ha scambiato messaggi
 */
export const getUsersMessagesCounterparts = <ThrowOnError extends boolean = false>(
  options: Options<GetUsersMessagesCounterpartsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUsersMessagesCounterpartsResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/users/messages-counterparts',
    ...options,
  });

/**
 * Restituisce il banner posizionato per slot
 */
export const getPositionedBannersBySlot = <ThrowOnError extends boolean = false>(
  options: Options<GetPositionedBannersBySlotData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPositionedBannersBySlotResponses, GetPositionedBannersBySlotErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{slot}',
    ...options,
  });

/**
 * Restituisce i banner posizionati paginati
 */
export const getPositionedBanners = <ThrowOnError extends boolean = false>(
  options?: Options<GetPositionedBannersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPositionedBannersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners',
    ...options,
  });

/**
 * Crea un nuovo banner posizionato
 */
export const postPositionedBanners = <ThrowOnError extends boolean = false>(
  options?: Options<PostPositionedBannersData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostPositionedBannersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Restituisce un banner posizionato specifico
 */
export const getPositionedBannersByIdById = <ThrowOnError extends boolean = false>(
  options: Options<GetPositionedBannersByIdByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPositionedBannersByIdByIdResponses,
    GetPositionedBannersByIdByIdErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/by-id/{id}',
    ...options,
  });

/**
 * Elimina un banner posizionato
 */
export const deletePositionedBannersById = <ThrowOnError extends boolean = false>(
  options: Options<DeletePositionedBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeletePositionedBannersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{id}',
    ...options,
  });

/**
 * Aggiorna un banner posizionato
 */
export const putPositionedBannersById = <ThrowOnError extends boolean = false>(
  options: Options<PutPositionedBannersByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutPositionedBannersByIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/positioned-banners/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Lista i premium tokens
 */
export const getPremiumTokens = <ThrowOnError extends boolean = false>(
  options?: Options<GetPremiumTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetPremiumTokensResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens',
    ...options,
  });

/**
 * Crea un nuovo premium token
 */
export const postPremiumTokens = <ThrowOnError extends boolean = false>(
  options?: Options<PostPremiumTokensData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostPremiumTokensResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un premium token
 */
export const deletePremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<DeletePremiumTokensByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeletePremiumTokensByIdResponses, DeletePremiumTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
  });

/**
 * Mostra un premium token specifico
 */
export const getPremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<GetPremiumTokensByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPremiumTokensByIdResponses, GetPremiumTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
  });

/**
 * Aggiorna un premium token
 */
export const putPremiumTokensById = <ThrowOnError extends boolean = false>(
  options: Options<PutPremiumTokensByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutPremiumTokensByIdResponses, PutPremiumTokensByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Invia email di membership per un premium token
 */
export const postPremiumTokensMembershipEmail = <ThrowOnError extends boolean = false>(
  options: Options<PostPremiumTokensMembershipEmailData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostPremiumTokensMembershipEmailResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/premium_tokens/membership_email',
    ...options,
  });

/**
 * Ottiene la cardinalità del ranking per l'anno corrente
 */
export const getCardinality = <ThrowOnError extends boolean = false>(
  options?: Options<GetCardinalityData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCardinalityResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/cardinality',
    ...options,
  });

/**
 * Salva un nuovo ranking per il giocatore corrente
 */
export const postCardinalitySave = <ThrowOnError extends boolean = false>(
  options: Options<PostCardinalitySaveData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostCardinalitySaveResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/cardinality/save',
    ...options,
  });

/**
 * Richiede il reset della password
 */
export const putResetPasswordRequest = <ThrowOnError extends boolean = false>(
  options: Options<PutResetPasswordRequestData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutResetPasswordRequestResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reset-password/request',
    ...options,
  });

/**
 * Resetta la password usando il token
 */
export const putResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<PutResetPasswordData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutResetPasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/reset-password',
    ...options,
  });

/**
 * Elimina la ricerca di competizioni salvata
 */
export const deleteSavedCompetitionSearch = <ThrowOnError extends boolean = false>(
  options?: Options<DeleteSavedCompetitionSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).delete<
    DeleteSavedCompetitionSearchResponses,
    DeleteSavedCompetitionSearchErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/saved-competition-search',
    ...options,
  });

/**
 * Ottiene la ricerca di competizioni salvata dell'utente
 */
export const getSavedCompetitionSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GetSavedCompetitionSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSavedCompetitionSearchResponses, GetSavedCompetitionSearchErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/saved-competition-search',
    ...options,
  });

/**
 * Crea o aggiorna la ricerca di competizioni salvata
 */
export const postSavedCompetitionSearch = <ThrowOnError extends boolean = false>(
  options?: Options<PostSavedCompetitionSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostSavedCompetitionSearchResponses, PostSavedCompetitionSearchErrors, ThrowOnError>(
    {
      security: [{ name: 'X-Api-Key', type: 'apiKey' }],
      url: '/saved-competition-search',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );

/**
 * Lista gli update tasks (richiede autorizzazione admin)
 */
export const getUpdateTasks = <ThrowOnError extends boolean = false>(
  options?: Options<GetUpdateTasksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUpdateTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks',
    ...options,
  });

/**
 * Crea un nuovo update task
 */
export const postUpdateTasks = <ThrowOnError extends boolean = false>(
  options?: Options<PostUpdateTasksData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUpdateTasksResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Esegue un update task specifico
 */
export const putUpdateTasksByIdRun = <ThrowOnError extends boolean = false>(
  options: Options<PutUpdateTasksByIdRunData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUpdateTasksByIdRunResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/run',
    ...options,
  });

/**
 * Imposta un update task come pending
 */
export const putUpdateTasksByIdSetPending = <ThrowOnError extends boolean = false>(
  options: Options<PutUpdateTasksByIdSetPendingData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUpdateTasksByIdSetPendingResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/{id}/set_pending',
    ...options,
  });

/**
 * Aggiorna la cache Redis
 */
export const postUpdateTasksCacheRefresh = <ThrowOnError extends boolean = false>(
  options?: Options<PostUpdateTasksCacheRefreshData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUpdateTasksCacheRefreshResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/cache_refresh',
    ...options,
  });

/**
 * Riavvia i server EC2
 */
export const postUpdateTasksRestartServers = <ThrowOnError extends boolean = false>(
  options?: Options<PostUpdateTasksRestartServersData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUpdateTasksRestartServersResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/restart_servers',
    ...options,
  });

/**
 * Esegue il ripristino di un dump del database
 */
export const postUpdateTasksRunRestoreDump = <ThrowOnError extends boolean = false>(
  options: Options<PostUpdateTasksRunRestoreDumpData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostUpdateTasksRunRestoreDumpResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/run-restore-dump',
    ...options,
  });

/**
 * Esegue un job asincrono specifico (richiede autorizzazione admin)
 */
export const postUpdateTasksRunAsyncJob = <ThrowOnError extends boolean = false>(
  options: Options<PostUpdateTasksRunAsyncJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostUpdateTasksRunAsyncJobResponses, PostUpdateTasksRunAsyncJobErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/update-tasks/run_async_job',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Lista i match utente
 */
export const getUserMatches = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserMatchesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetUserMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches',
    ...options,
  });

/**
 * Crea un nuovo match utente
 */
export const postUserMatches = <ThrowOnError extends boolean = false>(
  options?: Options<PostUserMatchesData, ThrowOnError>,
) =>
  (options?.client ?? client).post<PostUserMatchesResponses, unknown, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Elimina un match utente
 */
export const deleteUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<DeleteUserMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).delete<DeleteUserMatchesByIdResponses, DeleteUserMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
  });

/**
 * Mostra un match utente specifico
 */
export const getUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<GetUserMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetUserMatchesByIdResponses, GetUserMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
  });

/**
 * Aggiorna un match utente
 */
export const putUserMatchesById = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUserMatchesByIdResponses, PutUserMatchesByIdErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Conferma un match utente
 */
export const putUserMatchesByIdConfirm = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdConfirmData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUserMatchesByIdConfirmResponses, PutUserMatchesByIdConfirmErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/confirm',
    ...options,
  });

/**
 * Rifiuta un match utente
 */
export const putUserMatchesByIdReject = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdRejectData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUserMatchesByIdRejectResponses, PutUserMatchesByIdRejectErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/reject',
    ...options,
  });

/**
 * Aggiorna il risultato di un match utente
 */
export const putUserMatchesByIdResult = <ThrowOnError extends boolean = false>(
  options: Options<PutUserMatchesByIdResultData, ThrowOnError>,
) =>
  (options.client ?? client).put<PutUserMatchesByIdResultResponses, PutUserMatchesByIdResultErrors, ThrowOnError>({
    security: [{ name: 'X-Api-Key', type: 'apiKey' }],
    url: '/user-matches/{id}/result',
    ...options,
  });
